<div class="sidebar-wrapper">
  <app-sidebar-header (backButtonClicked)="onBack()" [showBackButton]="false">
    <div smallTitle>{{ model.id ? 'Edit' : 'Add' }} Change Action</div>
    <div mainTitle>General Information</div>
  </app-sidebar-header>
  <div class="main-content m-0 p-0 flex flex-col">
    <app-loading-bar
      class="w-full z-10"
      [ngClass]="{ invisible: !isLoadingPCOs() }"
      mode="indeterminate"
    ></app-loading-bar>
    <ng-scrollbar #scrollbar class="std-scrollbar flex-1" [appearance]="'compact'" orientation="vertical">
      <div class="flex my-2.5 mx-7 flex-col flex-1">
        <form class="flex flex-col h-full" #generalForm="ngForm" role="form">
          <app-input-upload
            [files]="model?.files"
            label="Drag or click to upload files"
            placeholder="Drag or click to upload files"
            (filesChanged)="filesChanged($event)"
            (removeFile)="removeFile($event)"
            [allowMultipleFiles]="true"
          >
          </app-input-upload>

          <app-dropdown
            [required]="true"
            [optionLabel]="null"
            [optionValue]="null"
            [disabled]="!!model.id"
            placeholder="Change Action Type"
            label="Change Action Type"
            name="Change Action Type"
            [(ngModel)]="model.type"
            [options]="changeActionTypes"
            (ngModelChange)="actionTypeChanged()"
            class="w-full"
          >
            <ng-template #selectedContent #optionContent let-option>
              <div
                [ngClass]="{
                  'disabled opacity-50': !allPCOs().length && option === CHANGE_ACTIONS_TYPE.CHANGE_ORDER_REQUEST,
                }"
                class="capitalize text-navy-900"
              >
                {{ option }}
              </div>
            </ng-template>
          </app-dropdown>

          <app-floating-input
            [required]="true"
            [(ngModel)]="model.title"
            name="title"
            label="Title"
            placeholder="Title"
            [disabled]="(PCOEditableFields$ | async)?.title === false && model.type === 'Potential Change Order'"
          ></app-floating-input>

          <div class="flex gap-4">
            <app-input-calendar
              [required]="true"
              [minStartDate]="(project$ | async)?.start_date"
              [(date)]="model.date"
              class="w-full"
              name="date"
              placeholder="Date"
              [disabled]="(PCOEditableFields$ | async)?.date === false && model.type === 'Potential Change Order'"
            ></app-input-calendar>

            @if (model.type === 'Potential Change Order') {
              <app-dropdown
                required
                [optionLabel]="null"
                [optionValue]="null"
                placeholder="Duration Extension"
                label="Duration Extension"
                name="duration"
                [(ngModel)]="model.duration_extension"
                [options]="possibleDurationExtensions"
                [disabled]="
                  (PCOEditableFields$ | async)?.duration_extension === false && model.type === 'Potential Change Order'
                "
                class="w-full"
              >
                <ng-template #selectedContent #optionContent let-option>
                  <div class="capitalize text-navy-900">{{ option }} Days</div>
                </ng-template>
              </app-dropdown>
            }
          </div>

          <div class="flex gap-4">
            <app-floating-input
              [ngClass]="{
                ' pointer-events-none':
                  (PCOEditableFields$ | async)?.number === false && model.type === 'Potential Change Order',
              }"
              [(ngModel)]="model.number"
              (ngModelChange)="NumberChanged($event)"
              label="Number"
              placeholder="Number"
              name="number"
              required
              [minLength]="1"
              [maxLength]="10"
              [disabled]="customIdDisabled"
              patternErrorMessage="Already taken"
              [iconClass]="customIdDisabled ? 'icon-text-edit' : 'icon-text-revert'"
              (iconClick)="onCustomIdIconClick()"
              class="w-full"
            ></app-floating-input>

            <app-dropdown
              required
              [optionLabel]="null"
              [optionValue]="null"
              [required]="true"
              placeholder="Status"
              label="Status"
              name="status"
              [(ngModel)]="model.status"
              [options]="statuses"
              [disabled]="!model.type || (PCOEditableFields$ | async)?.status === false"
              [appTooltip]="!model.type ? 'Change Action Type must be selected first.' : ''"
              tooltipPosition="bottom"
              class="w-full"
            >
              <ng-template #selectedContent #optionContent let-option>
                <div class="capitalize text-navy-900">{{ option }}</div>
              </ng-template>
            </app-dropdown>
          </div>

          <label class="flex gap-1 text-navy-600 text-xs mt-2 ml-1 mb-0.5">
            <span class="font-semibold"> Description</span>
            <span class="font-normal">(optional)</span>
          </label>
          <div
            [ngClass]="{
              'opacity-50 pointer-events-none':
                (PCOEditableFields$ | async)?.number === false && model.type === 'Potential Change Order',
            }"
            (click)="textAreaElement.focus()"
            class="textarea-wrapper cursor-text"
          >
            <textarea
              class="flex"
              #textAreaElement
              cdkTextareaAutosize
              name="note"
              [(ngModel)]="model.description"
            ></textarea>
          </div>
        </form>
      </div>
    </ng-scrollbar>
    <div class="my-6 mx-7 flex justify-end gap-4">
      @if (model.id && model.type === 'Potential Change Order') {
        <app-simple-button (click)="updatePco()" buttonStyle="color_accent_filled">Update</app-simple-button>
      } @else {
        <app-simple-button (click)="onNext()">Next</app-simple-button>
      }
    </div>
  </div>
</div>
